// src/layouts/WorkTeamSection/WorkTeamSection.js

import React from "react"
import { Link } from 'gatsby-plugin-modal-routing-3'
import styled from 'styled-components'
import { GatsbyImage } from "gatsby-plugin-image"

const WorkTeamSection = ({ workTeamSectionContent, workSectionTeamMembers }) => {

  return (
    <BlockContent>
      <div
      data-sal="slide-up"
      data-sal-duration="1000"
      data-sal-delay="300"
      data-sal-easing="ease"
      >
          <div class="team-copy" dangerouslySetInnerHTML={{ __html: workTeamSectionContent }} />

          <ul class="team-list">
            {workSectionTeamMembers.map(member => (
                <li>
                  {member.TeamMemberJobTitle.tmIncludeModal ? (
                  <Link to={`/about/meet-the-team/${member.slug}`} asModal >
                    <GatsbyImage image={member.TeamMemberJobTitle.tmSmallThumbnail.localFile.childImageSharp.gatsbyImageData} alt={member.title} />
                    <h3>{member.title}</h3>
                    <p>{member.TeamMemberJobTitle.tmJobTitle}</p>
                  </Link>
                  ) : (
                  <Link>
                    <GatsbyImage image={member.TeamMemberJobTitle.tmSmallThumbnail.localFile.childImageSharp.gatsbyImageData} alt={member.title} />
                    <h3>{member.title}</h3>
                    <p>{member.TeamMemberJobTitle.tmJobTitle}</p>
                  </Link>
                  )}
                </li>
            ))}
          </ul>

      </div>
    </BlockContent>
  )
}

const BlockContent = styled.section`
    max-width: 980px;
    width: 100%;
    margin: 100px auto;
    padding: 0 20px;
    > div {
      padding-left: 70px;
    }
    div.team-copy {
      h2 {
        font-family: "Nobel",sans-serif;
        font-weight: 700;
        font-style: normal;
        font-size: 50px;
        color: #2b2520;
        margin-top: 0;
      }
      h3 {
          font-family: "Nobel",sans-serif;
          font-weight: 700;
          font-style: normal;
          font-size: 50px;
          line-height: 60px;
          color: #2b2520;
          margin-top: 0;
      }
      h4 {
          font-family: "Nobel",sans-serif;
          font-weight: 700;
          font-style: normal;
          font-size: 40px;
          line-height: 48px;
          color: #2b2520;
          margin-top: 0;
      }
      p, ul {
        font-family: "Work Sans";
        font-size: 18px;
        font-weight: 400;
        line-height: 38px;
        color: #777c7c;
        margin-bottom: 0;
      }
    }
    ul.team-list {
      list-style: none;
      li {
        padding: 10px 0px;
        border-top: 1px solid #D7D2CB;
        margin-bottom: 0px;
        a {
          display: flex;
          align-items: center;
          text-decoration: none;
          &:hover {
            .gatsby-image-wrapper {
              transform: translateY(-2px);
            }
            h3 {
              color: #C44C4A;
            }
          }
        }
        &:last-child {
          border-bottom: 1px solid #D7D2CB;
        }
        .gatsby-image-wrapper {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          transition: all .3s cubic-bezier(.77,0,.175,1);
        }
        h3 {
          font-family: "Work Sans";
          margin-top: 0px;
          margin-bottom: 0px;
          font-size: 18px;
          font-weight: 700;
          width: 220px;
          margin-left: 20px;
          transition: all .3s cubic-bezier(.77,0,.175,1);
        }
        p {
          font-family: "Work Sans";
          font-size: 18px;
          font-weight: 400;
          color: #777C7C;
          line-height: 1;
        }
      }
    }
    @media(max-width:1000px) {
      max-width: 700px;
      flex-wrap: wrap;
      padding: 0px;
      div.team-copy {
        h2 {
          font-size: 44px;
          line-height: 1.3;
          margin-bottom: 10px;
        }
        h3 {
            font-size: 36px;
            line-height: 1.3;
            margin-bottom: 10px;
        }
        h4 {
            font-size: 28px;
            line-height: 1.3;
            margin-bottom: 10px;
        }
      }
    }
    @media(max-width:767px) {
      max-width: 500px;
      padding: 0;
      margin-top: 20px;
      margin-bottom: 20px;
      > div {
        padding-left: 0px;
      }
      div.team-copy {
        h2 {
          font-size: 36px;
        }
        h3 {
            font-size: 28px;
        }
        h4 {
            font-size: 20px;
        }
        p {
            font-size: 16px;
            line-height: 1.6;
        }
      }
      ul.team-list {
        li {
          h3 {
            font-size: 16px;
            width: 180px;
          }
          p {
            font-size: 16px;
          }
        }
      }
    }
    @media(max-width:600px) {
      ul.team-list {
        li {
          a {
            flex-direction: column;
            h3 {
              margin-left: 0px;
              margin-bottom: 5px;
              width: 100%;
              text-align: center;
            }
          }
          .gatsby-image-wrapper {
            margin-bottom: 10px;
          }
          
        }
      }
    }
`

export default WorkTeamSection